import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { PROYECT, api_get } from "services/api";
import {
  getStations,
  orderCompaniesAndStations,
} from "helpers/companiesNormalized";
import { convertToMap } from "helpers/convertToMap";

// data
const LOAD_DATA_BRANDS_SECTION = "LOAD_DATA_BRANDS_SECTION";
const SET_DATA_BRANDS_SECTION = "SET_DATA_BRANDS_SECTION";
const CLEAR_DATA_BRANDS_SECTION = "CLEAR_DATA_BRANDS_SECTION";
const ERROR_DATA_BRANDS_SECTION = "ERROR_DATA_BRANDS_SECTION";

// brands
const LOAD_BRANDS_BRANDS_SECTION = "LOAD_BRANDS_BRANDS_SECTION";
const SET_BRANDS_BRANDS_SECTION = "SET_BRANDS_BRANDS_SECTION";
const ERROR_BRANDS_BRANDS_SECTION = "ERROR_BRANDS_BRANDS_SECTION";

// filters
const CHANGE_COMPANY_BRANDS_SECTION = "CHANGE_COMPANY_BRANDS_SECTION";
const CHANGE_STATION_BRANDS_SECTION = "CHANGE_STATION_BRANDS_SECTION";

// config
const SET_CONFIG_TAB_BRANDS_SECTION = "SET_CONFIG_TAB_BRANDS_SECTION";
// config brand
const SET_CONFIG_PAGE_BRANDS_BRANDS_SECTION =
  "SET_CONFIG_PAGE_BRANDS_BRANDS_SECTION";
const SET_CONFIG_PAGE_SIZE_BRANDS_BRANDS_SECTION =
  "SET_CONFIG_PAGE_SIZE_BRANDS_BRANDS_SECTION";
const SET_CONFIG_SORTED_BRANDS_BRANDS_SECTION =
  "SET_CONFIG_SORTED_BRANDS_BRANDS_SECTION";
const SET_CONFIG_FILTERED_BRANDS_BRANDS_SECTION =
  "SET_CONFIG_FILTERED_BRANDS_UNITS_SECTION";
// config brand sales
const SET_CONFIG_PAGE_BRANDSSALES_BRANDS_SECTION =
  "SET_CONFIG_PAGE_BRANDSSALES_BRANDS_SECTION";
const SET_CONFIG_PAGE_SIZE_BRANDSSALES_BRANDS_SECTION =
  "SET_CONFIG_PAGE_SIZE_BRANDSSALES_BRANDS_SECTION";
const SET_CONFIG_SORTED_BRANDSSALES_BRANDS_SECTION =
  "SET_CONFIG_SORTED_BRANDSSALES_BRANDS_SECTION";
const SET_CONFIG_FILTERED_BRANDSSALES_BRANDS_SECTION =
  "SET_CONFIG_FILTERED_BRANDSSALES_BRANDS_SECTION";
// config brands stations
const SET_CONFIG_PAGE_BRANDSSTATION_BRANDS_SECTION =
  "SET_CONFIG_PAGE_BRANDSSTATION_BRANDS_SECTION";
const SET_CONFIG_PAGE_SIZE_BRANDSSTATION_BRANDS_SECTION =
  "SET_CONFIG_PAGE_SIZE_BRANDSSTATION_BRANDS_SECTION";
const SET_CONFIG_SORTED_BRANDSSTATION_BRANDS_SECTION =
  "SET_CONFIG_SORTED_BRANDSSTATION_BRANDS_SECTION";
const SET_CONFIG_FILTERED_BRANDSSTATION_BRANDS_SECTION =
  "SET_CONFIG_FILTERED_BRANDSSTATION_BRANDS_SECTION";

const CLEAR_ERROR_BRANDS_SECTION = "CLEAR_ERROR_BRANDS_SECTION";

const INITIAL_STATE = {
  // data
  stations: [],
  companies: [],
  brands: [],
  brandsSales: [],
  brandsStation: [],

  isLoading: false,
  error: false,
  errorMessage: "",
  isLoadingbrands: false,
  // filters
  companySelected: "",
  stationSelected: "",
  companyStations: [],
  // config
  config: {
    tab: 0,
    brands: {
      page: 0,
      pageSize: 50,
      sorted: [],
      filtered: [],
    },
    brandsSales: {
      page: 0,
      pageSize: 50,
      sorted: [],
      filtered: [],
    },
    brandsStation: {
      page: 0,
      pageSize: 50,
      sorted: [],
      filtered: [],
    },
  },
};

const brandsSectionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_DATA_BRANDS_SECTION:
      return {
        ...state,
        brands: [],
        brandsStation: [],
        brandsSales: [],
        companies: [],
        stations: [],
        isLoading: true,
        error: false,
        errorMessage: "",
      };
    case SET_DATA_BRANDS_SECTION:
      return {
        ...state,
        brands: payload.brands,
        brandsStation: payload.brandsStation,
        brandsSales: payload.brandsSales,
        companies: payload.companies,
        stations: payload.stations,
        isLoading: false,
      };
    case ERROR_DATA_BRANDS_SECTION:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case CLEAR_DATA_BRANDS_SECTION:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    case LOAD_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        units: [],
        isLoadingUnits: true,
        error: false,
        errorMessage: "",
      };
    case SET_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        units: payload.units,
        isLoadingUnits: false,
      };
    case ERROR_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        isLoadingUnits: false,
        error: true,
        errorMessage: payload.message,
      };

    case CHANGE_COMPANY_BRANDS_SECTION:
      return {
        ...state,
        companySelected: payload.company,
        companyStations: payload.stations,
      };
    case CHANGE_STATION_BRANDS_SECTION:
      return {
        ...state,
        stationSelected: payload,
      };

    //config
    case SET_CONFIG_TAB_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tab: payload,
        },
      };
    // config brands
    case SET_CONFIG_FILTERED_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brands: {
            ...state.config.brands,
            filtered: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_PAGE_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brands: {
            ...state.config.brands,
            page: payload,
          },
        },
      };
    case SET_CONFIG_PAGE_SIZE_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brands: {
            ...state.config.brands,
            pageSize: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_SORTED_BRANDS_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brands: {
            ...state.config.brands,
            sorted: payload,
            page: 0,
          },
        },
      };
    // config brands sales
    case SET_CONFIG_FILTERED_BRANDSSALES_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsSales: {
            ...state.config.brandsSales,
            filtered: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_PAGE_BRANDSSALES_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsSales: {
            ...state.config.brandsSales,
            page: payload,
          },
        },
      };
    case SET_CONFIG_PAGE_SIZE_BRANDSSALES_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsSales: {
            ...state.config.brandsSales,
            pageSize: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_SORTED_BRANDSSALES_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsSales: {
            ...state.config.brandsSales,
            sorted: payload,
            page: 0,
          },
        },
      };
    // config brands stations
    case SET_CONFIG_FILTERED_BRANDSSTATION_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsStation: {
            ...state.config.brandsStation,
            filtered: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_PAGE_BRANDSSTATION_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsStation: {
            ...state.config.brandsStation,
            page: payload,
          },
        },
      };
    case SET_CONFIG_PAGE_SIZE_BRANDSSTATION_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsStation: {
            ...state.config.brandsStation,
            pageSize: payload,
            page: 0,
          },
        },
      };
    case SET_CONFIG_SORTED_BRANDSSTATION_BRANDS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          brandsStation: {
            ...state.config.brandsStation,
            sorted: payload,
            page: 0,
          },
        },
      };

    case CLEAR_ERROR_BRANDS_SECTION:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };

    default:
      return state;
  }
};

function getData() {
  return {
    type: LOAD_DATA_BRANDS_SECTION,
  };
}
function setConfigTab(tab) {
  return {
    type: SET_CONFIG_TAB_BRANDS_SECTION,
    payload: tab,
  };
}
// config brands
function setConfigBrandsFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_BRANDS_BRANDS_SECTION,
    payload: filter,
  };
}
function setConfigBrandsPage(page) {
  return {
    type: SET_CONFIG_PAGE_BRANDS_BRANDS_SECTION,
    payload: page,
  };
}
function setConfigBrandsPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_BRANDS_BRANDS_SECTION,
    payload: pageSize,
  };
}
function setConfigBrandsSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_BRANDS_BRANDS_SECTION,
    payload: sorted,
  };
}
// config brands sales
function setConfigBrandsSalesFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_BRANDSSALES_BRANDS_SECTION,
    payload: filter,
  };
}
function setConfigBrandsSalesPage(page) {
  return {
    type: SET_CONFIG_PAGE_BRANDSSALES_BRANDS_SECTION,
    payload: page,
  };
}
function setConfigBrandsSalesPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_BRANDSSALES_BRANDS_SECTION,
    payload: pageSize,
  };
}
function setConfigBrandsSalesSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_BRANDSSALES_BRANDS_SECTION,
    payload: sorted,
  };
}
// config brands station
function setConfigBrandsStationFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_BRANDSSTATION_BRANDS_SECTION,
    payload: filter,
  };
}
function setConfigBrandsStationPage(page) {
  return {
    type: SET_CONFIG_PAGE_BRANDSSTATION_BRANDS_SECTION,
    payload: page,
  };
}
function setConfigBrandsStationPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_BRANDSSTATION_BRANDS_SECTION,
    payload: pageSize,
  };
}
function setConfigBrandsStationSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_BRANDSSTATION_BRANDS_SECTION,
    payload: sorted,
  };
}
function changeCompany(company, stations) {
  return {
    type: CHANGE_COMPANY_BRANDS_SECTION,
    payload: { company, stations },
  };
}
function changeStation(station) {
  return {
    type: CHANGE_STATION_BRANDS_SECTION,
    payload: station,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_BRANDS_SECTION,
  };
}

function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  const urlBrandsStation = `${process.env.REACT_APP_URL}${PROYECT}/brands`;
  const urlBrandsName = `${process.env.REACT_APP_URL}${PROYECT}/brands/names`;
  const urlBrandsSales = `${process.env.REACT_APP_URL}${PROYECT}/brands/sales`;
  try {
    const [companies, brandsStation, brands, brandsSales] = yield all([
      call(api_get, urlCompanies, auth),
      call(api_get, urlBrandsStation, auth),
      call(api_get, urlBrandsName, auth),
      call(api_get, urlBrandsSales, auth),
    ]);

    const stations = getStations(companies.companies);
    const orderedCompanies = orderCompaniesAndStations(companies.companies);
    const stationsMap = convertToMap(stations, "id");
    const brandsMap = convertToMap(brands, "id");
    const brandsStationNormalized = brandsStation.map((brand) => {
      return {
        ...brand,
        stationName: stationsMap[brand.idStation]
          ? stationsMap[brand.idStation].name
          : "",
      };
    });
    const brandsSalesNormalized = brandsSales.map((brand) => {
      return {
        ...brand,
        stationName: stationsMap[brand.idStation]
          ? stationsMap[brand.idStation].name
          : "",
        brandName: brandsMap[brand.idBrand]
          ? brandsMap[brand.idBrand].name
          : "",
      };
    });
    yield put({
      type: SET_DATA_BRANDS_SECTION,
      payload: {
        companies: orderedCompanies,
        brands,
        brandsStation: brandsStationNormalized,
        brandsSales: brandsSalesNormalized,
        stations,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_DATA_BRANDS_SECTION,
      payload: {
        message,
      },
    });
  }
}

function* brandsSectionSaga() {
  yield takeLatest(LOAD_DATA_BRANDS_SECTION, fetchData);
}

export {
  // reducer
  brandsSectionReducer,
  // actions
  getData,
  changeCompany,
  changeStation,
  setConfigBrandsFilter,
  setConfigBrandsPage,
  setConfigBrandsPageSize,
  setConfigBrandsSorted,
  setConfigBrandsSalesFilter,
  setConfigBrandsSalesPage,
  setConfigBrandsSalesPageSize,
  setConfigBrandsSalesSorted,
  setConfigBrandsStationFilter,
  setConfigBrandsStationPage,
  setConfigBrandsStationPageSize,
  setConfigBrandsStationSorted,
  setConfigTab,
  clearError,
  //sagas
  brandsSectionSaga,
};
